var a={modal:"corva_modal"};export{a as CLASSNAMES};
